module.exports = __webpack_public_path__ + "static/form_top-b8dec60920d314516fb47bda1bd4eb16.png";